import index from "./settings.vue";
export default index;
